import { matchPath } from 'react-router-dom';
import { routes } from 'routes';

/** True when URL is under `/deals/:dealId` or partner equivalent (any sub-path). */
export const isDealDetailPathname = (pathname: string): boolean => {
  const dealsRoot = routes.dealsPath();
  const partnerDealsRoot = routes.pDealsPath();

  const dealsMatch = matchPath<{ dealId: string }>(pathname, {
    path: `${dealsRoot}/:dealId`,
    exact: false,
  });

  if (dealsMatch?.params.dealId) return true;

  const pDealsMatch = matchPath<{ dealId: string }>(pathname, {
    path: `${partnerDealsRoot}/:dealId`,
    exact: false,
  });

  return !!pDealsMatch?.params.dealId;
};
